import React from "react";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AuditAttentionPanel({ actions, onView }) {
  const total = actions?.total ?? 0;
  if (!total) {
    return (
      <div className="flex items-center justify-between rounded-lg border border-emerald-200 bg-emerald-50/70 px-4 py-2.5" data-testid="audits-qa-attention-none">
        <div className="flex items-center gap-2 text-emerald-900">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
          <span className="text-xs font-medium">All caught up — no audit actions require attention right now.</span>
        </div>
      </div>
    );
  }
  const ov = actions.overdue_audits?.length || 0;
  const low = actions.low_score?.length || 0;
  const oa = actions.overdue_actions?.length || 0;
  const sig = actions.unresolved_significant?.length || 0;
  return (
    <div className="flex items-center justify-between rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5" data-testid="audits-qa-attention">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-amber-100 border border-amber-200 flex items-center justify-center">
          <AlertTriangle className="w-4 h-4 text-amber-700" />
        </div>
        <div className="text-xs">
          <div className="font-medium text-amber-900">{total} audit action{total === 1 ? "" : "s"} require attention</div>
          <div className="text-amber-800/80 mt-0.5">
            {ov > 0 && <span className="mr-2">{ov} overdue audit{ov === 1 ? "" : "s"}</span>}
            {low > 0 && <span className="mr-2">· {low} low-scoring</span>}
            {oa > 0 && <span className="mr-2">· {oa} overdue action{oa === 1 ? "" : "s"}</span>}
            {sig > 0 && <span>· {sig} significant finding{sig === 1 ? "" : "s"}</span>}
          </div>
        </div>
      </div>
      <Button variant="outline" size="sm" onClick={onView} data-testid="btn-audits-attention-view" className="h-8 text-xs border-amber-300 hover:bg-amber-100 text-amber-900">
        View Actions <ChevronRight className="w-3.5 h-3.5 ml-1" />
      </Button>
    </div>
  );
}
